import type { PokemonBaseStats } from '../data/schemas/entities/pokemon';
import type { DerivedStats } from './types';

/** See specs/battle/damage-formula.md */
export function deriveStats(base: PokemonBaseStats, level: number): DerivedStats {
  const maxHp = Math.floor((2 * base.hp * level) / 100) + level + 10;
  const scale = (stat: number) => Math.floor((2 * stat * level) / 100) + 5;
  return {
    maxHp,
    attack: scale(base.attack),
    defense: scale(base.defense),
    spAttack: scale(base.spAttack),
    spDefense: scale(base.spDefense),
    speed: scale(base.speed),
  };
}
